export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 7_03.54d73b96.jpg";